import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Statistic/style";
import _Statistic from "@arco-design/web-react/es/Statistic";
import React, { useRef, useState } from 'react';
import axios from 'axios';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function RegisterForm() {
  const Countdown = _Statistic.Countdown;
  const now = Date.now();

  const [form] = _Form.useForm();

  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = React.useState(true);
  const [countdownTime, setCountdownTime] = useState(0);
  const t = useLocale(locale);

  function register(params) {
    setErrorMessage('');
    setLoading(true);
    axios.post('/api/register', params).then(res => {
      const {
        status,
        msg
      } = res.data;

      if (status !== 200) {
        console.log(status);

        _Message.error({
          content: msg,
          showIcon: true,
          position: 'top'
        });
      } else {
        _Message.success({
          content: msg,
          showIcon: true,
          position: 'top'
        });

        window.location.href = '/login';
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }

  function onSubmitClick() {
    formRef.current.validate().then(values => {
      register(values);
    });
  }

  async function sendButtonClick() {
    console.log(formRef.current.getFieldValue('email'));

    try {
      await form.validate(['email']);
      setCountdownTime(60);
      setTimeout(() => {
        setCountdownTime(0);
      }, 60000);
      axios.post('/api/send_email_verify_code', {
        email: formRef.current.getFieldValue('email')
      }).then(res => {
        const {
          msg
        } = res.data;

        _Message.success({
          content: msg,
          showIcon: true,
          position: 'top'
        });
      }).catch(err => {
        console.log(err);
      });
    } catch (e) {// Message.error('Email 校验失败');
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, t['register.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Modal, {
    title: "Warning!",
    visible: visible,
    onOk: () => setVisible(false),
    onCancel: () => setVisible(false),
    autoFocus: false,
    focusLock: true
  }, t['register.form.modal.msg'], /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    style: {
      color: 'red'
    },
    href: "https://www.reddit.com/r/F1TV/comments/159l0ea/vpn_shakedown_2023/?sort=new"
  }, "F1TV Pro_vpn_shakedown_2023_reddit\xA0 \xA0"), ' ', /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    style: {
      color: 'red'
    },
    href: "https://www.formula1.com/en/toolbar/content_schedule.html"
  }, "F1 Content Schedule")), /*#__PURE__*/React.createElement(_Form, {
    form: form,
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      email: '',
      password: '',
      confirmPassword: ''
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      type: 'email',
      message: t['register.form.mail.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconEmail, null),
    placeholder: t['register.form.mail.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "mail_code",
    rules: [{
      required: true,
      message: t['register.form.mail_code.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconStamp, null),
    placeholder: t['register.form.mail_code.placeholder'],
    addAfter: /*#__PURE__*/React.createElement(_Button, {
      disabled: countdownTime != 0,
      type: "primary",
      onClick: sendButtonClick
    }, countdownTime == 0 && 'Send', countdownTime != 0 && /*#__PURE__*/React.createElement(Countdown, {
      value: now + 1000 * 60,
      format: "s",
      now: now,
      styleValue: {
        color: 'white',
        fontSize: 14
      }
    })),
    afterStyle: {
      padding: 0
    },
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['register.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['register.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "confirmPassword",
    rules: [{
      validator: (v, cb) => {
        if (!v) {
          return cb(t['register.form.confirmPassword.errMsg']);
        } else if (form.getFieldValue('password') !== v) {
          return cb(t['register.form.confirmPassword.confirm.errMsg']);
        }

        cb(null);
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['register.form.confirmPassword.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['register.form.register']))));
}